import React from 'react';
// import logo from 'assets/img/icons/logotipo-horizontal-ctcp.svg';

import CTCPIMAGE from 'assets/img/icons/logotipo-horizontal-ctcp.svg';
// import CTCPIMAGEDARK from 'assets/img/icons/logotipo-horizontal-ctcp.svg';

import classNames from 'classnames';

interface LogoProps {
  width?: number;
  height?: number;
  text?: boolean;
  textClass?: string;
  className?: string;
}

const Logo = ({
  width = 507,
  height = 125,
  text = true,
  textClass,
  className
}: LogoProps) => {
  return (
    <div className={classNames(className, 'd-flex align-items-center')}>
      <img src={CTCPIMAGE} alt="phoenix" width={width} height={height} />
      {text && (
        <div>
          <p className={classNames(textClass, 'logo-text ms-2')}>Centro</p>
          <p className={classNames(textClass, 'logo-text ms-2')}>
            Tecnológico do
          </p>
          <p className={classNames(textClass, 'logo-text ms-2')}>Calçado de</p>
          <p className={classNames(textClass, 'logo-text ms-2')}>Portugal</p>
        </div>
      )}
    </div>
  );
};

export default Logo;
